<template>
  <v-row class="pa-0 ma-0">
    <v-col cols="12" class="pa-0">
      <v-row class="mx-2 align-center b-B" style="height:44px;">
        <v-col :cols="header.width" :class="'customHeader py-0 px-1'" v-for="(header, index) in headers" :key="header.key">
          <v-sheet class="pa-0" color="transparent">
            <span @click="onSort(index)" class="pa-0" @mouseenter="onMouse(index, true)" @mouseleave="onMouse(index, false)">{{ header.title }}</span>
            <v-icon class="pa-0 ma-0" :color="header.over ? 'grey' : 'transparent'" >{{ getSortIcon(index) }}</v-icon>
          </v-sheet>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12" class="py-0">
      <div class='overflow-y-auto' :style="contentsHeight">
        <v-virtual-scroll v-if="change"
          :items="filterItems"
          :item-height="42"
          class='overflow-x-hidden'
        >
          <template v-slot:default="{ item }">
            <v-col cols="12" class="py-0" style="height: 42px !important;">
              <v-row class="py-2 customLine" align="center">
                <v-col :cols="header.width" :class="'py-0 px-1'" v-for="(header) in headers" :key="header.key" @click.right.stop="onSelectRight(item, $event)" @click.stop="(header.key != 'ycs' && header.key != 'chargeName') ? onSelect(item) : ''">
                  <template v-if="header.key == 'displayName'">
                    <v-row class="ma-0 pa-0" align="center">
                      <v-col v-if="item._isIcon" cols="2" class="pa-0" align="center">
                        <v-avatar color="grey lighten-3" size="36">
                          <img v-if="getProfileImage(item)" :src="getProfileImage(item)"/>
                          <v-icon v-else>mdi-account-box</v-icon>
                        </v-avatar>
                      </v-col>
                      <v-col class="pa-0">
                        <template v-if="item.restore">
                          <v-row class="ma-0 pa-0" align="center">
                            <v-col cols="10" class="pa-0">
                              <p class="ma-0" style="overflow: hidden !important; text-overflow: ellipsis !important; white-space: nowrap;">{{ item[header.key] }}</p>
                            </v-col>
                            <v-col cols="2" class="pa-0">
                              <v-icon size="18">mdi-alpha-r-circle-outline</v-icon>
                            </v-col>
                          </v-row>
                        </template>
                        <template v-else>
                          <p class="ma-0" style="overflow: hidden !important; text-overflow: ellipsis !important; white-space: nowrap;">{{ item[header.key] }}</p>
                        </template>
                      </v-col>
                    </v-row>
                  </template>
                  <template v-else-if="header.key == 'ycs'">
                    <v-col cols="1" class="pa-0 ma-0">
                      <v-edit-dialog :ref="item.key">
                        {{ item._ycs }}
                        <template v-slot:input>
                          <v-select
                          style="width:48px;"
                            ref="tygs"
                            :items="$YCSS"
                            v-model="item.tyg"
                            item-text="name"
                            item-value="key"
                            @change="save(item)"
                          ></v-select>
                        </template>
                      </v-edit-dialog>
                    </v-col>
                  </template>
                  <template v-else-if="header.key == 'chargeName'">
                    <v-col class="pa-0 ma-0">
                      <v-edit-dialog :ref="'charge_' + item.key">
                        <v-chip small :color="item._groupColor" depressed dark>
                          {{ item[header.key] }}
                        </v-chip>
                        <template v-slot:input>
                          <v-select
                            style="width:80px;"
                            ref="charges"
                            :items="item._charges"
                            v-model="item.charge"
                            item-text="name"
                            item-value="key"
                            @change="changeCharge(item)"
                            class="caption"
                          ></v-select>
                        </template>
                      </v-edit-dialog>
                    </v-col>
                  </template>
                  <template v-else-if="header.key == 'gradeName'">
                    <template v-if="item._grade">
                      <p class="ma-0" style="overflow: hidden !important; text-overflow: ellipsis !important; white-space: nowrap;">{{ item[header.key] }}</p>
                    </template>
                    <template v-else>
                      <p class="ma-0 warning--text" style="overflow: hidden !important; text-overflow: ellipsis !important; white-space: nowrap;">{{ item[header.key] }}</p>
                    </template>
                  </template>
                  <template v-else>
                    <p class="ma-0" style="overflow: hidden !important; text-overflow: ellipsis !important; white-space: nowrap;">{{ item[header.key] }}</p>
                  </template>
                </v-col>
              </v-row>
            </v-col>
          </template>
        </v-virtual-scroll>
      </div>
    </v-col>

    <div v-if="showMenu">
      <v-row justify="space-around">
        <v-menu
          v-model='showMenu'
          offset-y
          absolute
          transition="slide-y-transition"
          :position-x="x"
          :position-y="y"
        >
          <v-list class="pa-0">
            <v-list-item
              v-for="mitem in items"
              :key="mitem"
              class="py-0"
            >
              <v-chip dark outlined disabled color="error" class="mr-2">{{ item.name}}</v-chip>
              <v-chip dark color="error" @click="onSelectRightClick()">{{ mitem }}</v-chip>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-row>
    </div>

    <div v-if="restoreDialog">
      <app-basic-dialog
        @dismissed="onDismissed"
        title="復塾"
        :message="item.name + ' の基本情報を複製・保存します。よろしいですか?'"
        :dialog='restoreDialog'
        :color="'error'"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import Moment from 'moment-timezone'
import { extendMoment } from 'moment-range'
const moment = extendMoment(Moment)
export default {
  props: [ 'status', 'search', 'selects', 'group', 'type', 'contentsHeight' ],
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      scholae: 'scholae/scholae',
      students: 'students/students',
      windowSize: 'shared/windowSize'
    }),
    mySchool () {
      if (this.data) {
        var keys = Object.keys(this.data.schools)
        for (var i in keys) {
          if (this.data.schools[keys[i]]) {
            return keys[i]
          }
        }
      }
      return null
    },
    filterItems () {
      var vm = this
      var temp = []
      if (!this.change) {
        return temp
      }
      for (var i in this.students) {
        var item = JSON.parse(JSON.stringify(this.students[i]))
        if (item.enable) {
          if (!this.checkPrivileges('edit')) {
            if (!this.checkStatus(item)) {
              continue
            }
          }
          if (!this.checkGroup(item)) {
            continue
          }
          if (this.selects) {
            if (!this.selects[item.key]) {
              continue
            }
            item.gradeName = this.getGradeName(this.getGrade(item))
            item.className = this.getClassroomName(item)
            item.chargeName = this.getCharge(item)
            item['schola'] = this.getSchoolName(item)
            item['dts'] = this.getLastDTS(item)
            item['ycs'] = item.tyg
            item['displayName'] = item.name !== 'null' && item.name ? item.name : item.seiY + ' ' + item.meiY
            item['_isIcon'] = this.checkIconViewable()
            item['_ycs'] = this.getYCS(item)
            item['_groupColor'] = this.getGroupColorFromCharge(item)
            item['_charges'] = this.getCharges(item)
            item['_grade'] = this.checkGrade(item)
            temp.push(item)
            continue
          }
          if (!this.checkStatus(item)) {
            continue
          }
          if (this.search) {
            var name = item.name
            if (name.indexOf(this.search) === -1) {
              continue
            }
          }
          item.gradeName = this.getGradeName(this.getGrade(item))
          item.className = this.getClassroomName(item)
          item.chargeName = this.getCharge(item)
          item['schola'] = this.getSchoolName(item)
          item['dts'] = this.getLastDTS(item)
          item['ycs'] = item.tyg
          item['displayName'] = item.name !== 'null' && item.name ? item.name : item.seiY + ' ' + item.meiY
          item['_isIcon'] = this.checkIconViewable()
          item['_ycs'] = this.getYCS(item)
          item['_groupColor'] = this.getGroupColorFromCharge(item)
          item['_charges'] = this.getCharges(item)
          item['_grade'] = this.checkGrade(item)
          temp.push(item)
        }
      }
      var key = null
      for (i in this.headers) {
        if (this.headers[i].value) {
          key = this.headers[i].key
          if (key === 'displayName') {
            key = 'seiY'
          }
          if (key === 'gradeName') {
            key = 'grade'
          }
          if (this.headers[i].value === 1) {
            temp.sort(function (a, b) {
              var ak = a[key]
              var bk = b[key]
              if (key === 'grade') {
                ak = vm.getGrade(a)
                bk = vm.getGrade(b)
              }
              if (ak > bk) return -1
              if (ak < bk) return 1
              return 0
            })
          } else {
            temp.sort(function (a, b) {
              var ak = a[key]
              var bk = b[key]
              if (key === 'grade') {
                ak = vm.getGrade(a)
                bk = vm.getGrade(b)
              }
              if (ak < bk) return -1
              if (ak > bk) return 1
              return 0
            })
          }
          break
        }
      }
      this.$emit('onUpdateNumber', temp.length)
      return temp
    }
  },
  watch: {
    $route (to, from) {
      if (this.$route.path === '/students') {
        this.change = true
      } else {
        this.change = false
      }
    }
  },
  data () {
    return {
      loading: false,
      sortIcons: [
        'mdi-menu-swap',
        'mdi-menu-down',
        'mdi-menu-up'
      ],
      headers: [
        { over: false, value: 0, title: '氏名', key: 'displayName', width: '3' },
        { over: false, value: 0, title: '学年', key: 'gradeName', width: '2' },
        { over: false, value: 0, title: '学校名', key: 'schola', width: '2' },
        { over: false, value: 0, title: '教室', key: 'className', width: '2' },
        { over: false, value: 0, title: 'DTS', key: 'dts', width: '1' },
        { over: false, value: 0, title: 'YCS', key: 'ycs', width: '1' },
        { over: false, value: 0, title: '担当', key: 'chargeName', width: '1' }
      ],
      showMenu: false,
      restoreDialog: false,
      x: 0,
      y: 0,
      change: false,
      items: [ '復塾' ]
    }
  },
  created () {
    this.change = false
  },
  mounted () {
    this.$nextTick(function () {
      this.change = true
    })
  },
  methods: {
    getCharges (item) {
      var temp = []
      var vm = this
      var group = null
      var keys = Object.keys(item.groups)
      for (var i in keys) {
        if (item.groups[keys[i]]) {
          group = keys[i]
          break
        }
      }
      if (vm.mySchool !== null) {
        temp = this.users.filter(function (user) {
          if (!user.schools[vm.mySchool]) {
            return false
          }
          if (group === null) {
            return true
          }
          return user.groups[group]
        })
      }
      return temp
    },
    getSortIcon (item) {
      return this.sortIcons[this.headers[item].value]
    },
    getProfileImage (item) {
      if (item && item.avatar) {
        return item.avatar.thumbnail
      }
      return null
    },
    getClassroomName (item) {
      var keys = Object.keys(item.groups)
      for (var i in keys) {
        for (var g in this.groups) {
          if (this.groups[g].key === keys[i]) {
            return this.groups[g].name
          }
        }
      }
      return ''
    },
    getSchoolName (item) {
      const index = this.scholae.findIndex(schola => schola.key === item.school)
      if (index !== -1) {
        return this.scholae[index].name
      }
      return ''
    },
    getCharacteristics (item) {
      var len = 0
      if (item.characteristics) {
        for (var i in item.characteristics) {
          if (item.characteristics[i].done) {
            len += 1
          }
        }
      }
      return len
    },
    getLastDTS (item) {
      var temp = 'N/A'
      for (var i in item.events) {
        if (item.events[i].type === 1) {
          moment.tz.setDefault('Asia/Tokyo')
          var start = moment(item.events[i].date1)
          var end = moment(new Date())
          temp = '+ ' + end.diff(start, 'days') + '日'
          break
        }
      }
      return temp
    },
    getYCS (item) {
      const index = this.$YCSS.findIndex(tyg => tyg.key === item.tyg)
      if (index !== -1) {
        return this.$YCSS[index].name
      }
      return 'N/A'
    },
    getCharge (item) {
      const index = this.users.findIndex(user => user.key === item.charge)
      if (index !== -1) {
        return this.users[index].sei
      }
      return ''
    },
    getGroupColorFromCharge (item) {
      var keys = Object.keys(item.groups)
      for (var i in keys) {
        if (item.groups[keys[i]]) {
          var index = this.groups.findIndex(g => g.key === keys[i])
          if (index !== -1) {
            return this.groups[index].color ? this.groups[index].color : 'primary'
          }
        }
      }
      return 'primary'
    },
    checkGrade (item) {
      return moment(item.birth).isValid()
    },
    checkIconViewable () {
      if (this.data && this.data.schools) {
        var keys = Object.keys(this.data.schools)
        for (var i in keys) {
          if (this.data.schools[keys[i]]) {
            var index = this.schools.findIndex(school => school.key === keys[i])
            if (index !== -1) {
              return this.schools[index].studentsIcon
            }
          }
        }
      }
      return false
    },
    checkGroup (item) {
      if (this.group === '*') {
        return true
      }
      var keys = Object.keys(item.groups)
      for (var i in keys) {
        if (this.group === keys[i]) {
          return true
        }
      }
      return false
    },
    checkStatus (item) {
      if (this.status === 1) {
        return item.status === this.$STATUS_ADMISSION && this.checkGroup(item)
      }
      if (this.status === 2) {
        return item.status < this.$STATUS_ADMISSION
      }
      if (this.status === 3) {
        return item.status === this.$STATUS_GRADUATION && this.checkGroup(item)
      }
      if (this.status === 4) {
        return item.status === this.$STATUS_LOSE
      }
    },
    onMouse (item, value) {
      this.headers[item].over = value
    },
    onSort (item) {
      var temp = this.headers[item].value += 1
      if (temp === 3) {
        temp = 0
      }
      for (var i in this.headers) {
        this.headers[i].value = 0
      }
      this.headers[item].value = temp
    },
    onClear () {
      this.search = null
    },
    onSelect (item) {
      this.$emit('onSelect', item)
    },
    onSelectRight (item, e) {
      e.preventDefault()
      if (item.status === 7) {
        this.x = e.clientX
        this.y = e.clientY
        this.showMenu = true
        this.item = JSON.parse(JSON.stringify(item))
      }
    },
    onSelectRightClick () {
      this.restoreDialog = true
    },
    onDismissed: function (value) {
      var vm = this
      if (this.restoreDialog) {
        this.restoreDialog = false
        if (value) {
          this.item.key = null
          this.item.status = 6
          this.item.admission = moment().format('YYYY-MM-DD')
          this.item['restore'] = true
          this.item.imported = true
          var event = JSON.parse(JSON.stringify(this.$store.getters['students/event']))
          event.date1 = this.item.admission
          event.charge = this.user.uid
          event.status = 5
          event.id = 1
          event.createdAt = event.updatedAt = parseInt(new Date().getTime())
          this.item.events = []
          this.item.events.push(event)
          var payload = JSON.parse(JSON.stringify(this.item))
          payload['createdAt'] = parseInt(new Date().getTime())
          payload['updatedAt'] = parseInt(new Date().getTime())
          this.$store.dispatch('students/write', JSON.parse(JSON.stringify(payload))).then((resp) => {
            vm.item.key = resp.key
            vm.$emit('onSelect', vm.item)
          })
        }
        return
      }
      this.studentDialog = false
    },
    save (item) {
      var vm = this
      this.$refs[item.key][0].isActive = false
      this.loading = true
      this.$nextTick(function () {
        var payload = JSON.parse(JSON.stringify(vm.$store.getters['students/initial']))
        var keys = Object.keys(payload)
        for (var i in keys) {
          payload[keys[i]] = item[keys[i]]
        }
        var event = JSON.parse(JSON.stringify(vm.$store.getters['students/event']))
        event.grade = this.getGrade(payload)
        event.status = payload.status
        event.type = 4
        event.tyg = item.tyg
        moment.tz.setDefault('Asia/Tokyo')
        event.updatedAt = parseInt(new Date().getTime())
        event.id = payload.events.length + 1
        event.createdAt = parseInt(new Date().getTime())
        payload.events.unshift(event)
        event.charge = this.user.uid

        payload['updatedAt'] = parseInt(new Date().getTime())
        vm.$store.dispatch('students/write', JSON.parse(JSON.stringify(payload))).then((resp) => {
          vm.loading = false
        })
      })
    },
    changeCharge (item) {
      var vm = this
      this.$refs['charge_' + item.key][0].isActive = false
      this.loading = true
      this.$nextTick(function () {
        var payload = JSON.parse(JSON.stringify(vm.$store.getters['students/initial']))
        var keys = Object.keys(payload)
        for (var i in keys) {
          payload[keys[i]] = item[keys[i]]
        }
        payload['updatedAt'] = parseInt(new Date().getTime())
        vm.$store.dispatch('students/write', JSON.parse(JSON.stringify(payload))).then((resp) => {
          vm.loading = false
        })
      })
    }
  }
}
</script>

<style scoped>
img {
  object-fit: cover !important;
}

.scroller {
  height: 100%;
}

.customHeader {
  cursor: pointer;
  user-select: none;
}

.customLine {
  cursor: pointer;
  user-select: none;
}

.customLine:hover {
  background-color: #CCCCCC20;
}

.b-B {
  border-bottom: 1px solid #1976D2 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 8px;
}
::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background-color: rgba(0,0,0,.5);
    box-shadow: 0 0 1px rgba(255,255,255,.3);
}
</style>
